import script from "./InputArea.vue?vue&type=script&setup=true&lang=ts"
export * from "./InputArea.vue?vue&type=script&setup=true&lang=ts"

import "./InputArea.vue?vue&type=style&index=0&id=4700105b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4700105b"]])

export default __exports__